import React, { Component } from 'react';
import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import { getPricing } from '../../actions/pay.js';
import { updatePaperInput, getSession1, getSession2, updateStep2 } from '../../actions/paper.js';
import calculatePrice from '../../util/calculatePrice';
import FAQ from './FAQ';
import ReactModal from 'react-modal';
import classname from 'classnames';
import { openExtraModal,closeExtraModal, openBronzeExampleModal, closeBronzeExampleModal, openSilverExampleModal, closeSilverExampleModal, openGoldExampleModal, closeGoldExampleModal } from '../../actions/modals.js';
import TopNav from '../includes/TopNav.js';
import Slider from 'react-slick';
import ReactTooltip from 'react-tooltip';
import {Helmet} from 'react-helmet';
import {capitalize, empToPrmLevelTranslate} from '../../util/displayUtils';
import { trackPage } from '../../util/analytics.js';
import Bubbles from './Bubbles';

function NextArrow(props) {
  const {className, style, onClick} = props
  return (
    <div
      className={className}
      style={{...style, display: 'block', borderRadius: '10px'}}
      onClick={onClick}
    ></div>
  );
}

function PrevArrow(props) {
  const {className, style, onClick} = props
  return (
    <div
      className={className}
      style={{...style, display: 'block'}}
      onClick={onClick}
    ></div>
  );
}


class Step2Page extends Component{
  constructor(props) {
    super(props);
    this.props.dispatch(getPricing());
    this.props.dispatch(getSession1(function(){
      var data = calculatePrice(this.props.Paper);
    }.bind(this)));
    this.state = {
      editorCarouselButtonText: 'Click to Learn About Our Editing Levels',
      editorCarouselClasses: 'pricing_details carousel carousel-hide'
    };
  }
  componentDidMount(){
    this.props.dispatch(getSession2());
    trackPage('step2');    
  }
  ChangeStep(level){
    if(!this.props.Paper.paper.editor_level || !this.props.Paper.someLevelSelected){
      alert("Please make a selection from the options chart.");
      level.preventDefault();
      level.stopPropagation();
      return false;
    } else {
      window.scrollTo(0, 0);
    }
  }
  updatePaper(level, time_limit){
    this.props.dispatch(updateStep2(level, time_limit));
    var data = calculatePrice(this.props.Paper);
  }
  updatePaperMobile(el, what) {
    if(what == 'editor_level') {
      this.updatePaper(el.target.value, this.props.Paper.paper.time_limit);
    } else if(what == 'time_limit') {
      this.updatePaper(this.props.Paper.paper.editor_level, el.target.value);
    }
  }
  openBronzeExampleModal(e){
    this.props.dispatch(openBronzeExampleModal());
  }
  closeBronzeExampleModal(e){
    this.props.dispatch(closeBronzeExampleModal());
  }
  openSilverExampleModal(e){
    this.props.dispatch(openSilverExampleModal());
  }
  closeSilverExampleModal(e){
    this.props.dispatch(closeSilverExampleModal());
  }
  openGoldExampleModal(e){
    this.props.dispatch(openGoldExampleModal());
  }
  closeGoldExampleModal(e){
    this.props.dispatch(closeGoldExampleModal());
  }
  openFAQModal(e){
    this.props.dispatch(openExtraModal());
  }
  closeExtraModal(e){
    this.props.dispatch(closeExtraModal());
  }
  toggleCarousel() {
    var classes = this.state.editorCarouselClasses.split(' ');
    var isHidden = false;
    for(var i=0;i<classes.length;i++) {
      if(classes[i] == 'carousel-hide') {
        isHidden = true;
      }
    }
    if(isHidden) {
      this.setState({
        editorCarouselButtonText: 'Close Editor Levels Info',
        editorCarouselClasses: 'pricing_details carousel'
      });
    } else {
      this.setState({
        editorCarouselButtonText: 'Click to Learn About Our Editing Levels',
        editorCarouselClasses: 'pricing_details carousel carousel-hide'
      });
    }
  }
  render() {
    var settings = {
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 7000,      
      speed: 500,
      arrows: true,
      nextArrow : <NextArrow />,
      prevArrow : <PrevArrow />,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    var button_next_disabled = true;
    if(this.props.Paper.paper.editor_level && this.props.Paper.someLevelSelected) {
      button_next_disabled = false;
    }
    var active_Next = classname({
      'button'       : true,
      'next'         : true,
      'inactive-next': button_next_disabled
    });
    var pages = Math.ceil((parseInt(this.props.Paper.paper.word_count) || 0) / 325);
    let make3grey = false;
    let make12grey = false;
    let make24grey = false;
    let make72grey = false;
    let make96grey = false;
    let make120grey = false;
    let make240grey = false;
    var titleVars = {
      "3": "",
      "12": "",
      "24": "",
      "72": "",
      "96": "",
      "120": "",
      "240": "",
    }
    if (parseInt(this.props.Paper.paper.word_count) > 110000) {
        alert("Please lower your word count or submit another document")
        this.props.Paper.paper.word_count = parseInt('100900');
        make240grey = true;
        make120grey = true;
        make96grey = true;
        make72grey = true;
        make24grey = true;
        make3grey = true;
        make12grey = true;
        for(var i in titleVars) {
          titleVars[i] = "Your word count exceeds the word limit for this turnaround time";
        }
    }else if(parseInt(this.props.Paper.paper.word_count) > 40500 ) {
      make120grey = true;
      make96grey = true;
      make72grey = true;
      make24grey = true;
      make3grey = true;
      make12grey = true;
      for(var i in titleVars) {
        if(parseInt(i) < 240) 
          titleVars[i] = "Your word count exceeds the word limit for this turnaround time";
      }
    } else if(parseInt(this.props.Paper.paper.word_count) > 32500 ) {
      make96grey = true;
      make72grey = true;
      make24grey = true;
      make3grey = true;
      make12grey = true;
      for(var i in titleVars) {
        if(parseInt(i) < 120) 
          titleVars[i] = "Your word count exceeds the word limit for this turnaround time";
      }
    }else if(parseInt(this.props.Paper.paper.word_count) > 19500 ) {
        make72grey = true;
        make24grey = true;
        make3grey = true;
        make12grey = true;
        for(var i in titleVars) {
          if(parseInt(i) < 96) 
            titleVars[i] = "Your word count exceeds the word limit for this turnaround time";
        }
    }else if(parseInt(this.props.Paper.paper.word_count) > 9100) {
        make24grey = true;
        make3grey = true;
        make12grey = true;
        for(var i in titleVars) {
          if(parseInt(i) < 72) 
            titleVars[i] = "Your word count exceeds the word limit for this turnaround time";
        }
    }else if(parseInt(this.props.Paper.paper.word_count) > 5850){
        make12grey = true;
        make3grey = true;
        for(var i in titleVars) {
          if(parseInt(i) < 24) 
            titleVars[i] = "Your word count exceeds the word limit for this turnaround time";
        }
    }else if (parseInt(this.props.Paper.paper.word_count) > 2275) {
        make3grey = true;
        for(var i in titleVars) {
          if(i == "3") 
            titleVars[i] = "Your word count exceeds the word limit for this turnaround time";
        }
    }
    const levelSelectOptionsArr = ['Select...', 'pro', 'gold', 'silver'];
    var levelSelectOptions = levelSelectOptionsArr.map(function(lvl, key) {
      if(lvl == 'Select...') {
        return (<option key="select" value="">{lvl}</option>);
      }
      var selected = false;
      var disabled = false;
      var tl = this.props.Paper.paper.time_limit;
      if(tl <= 7 && lvl == 'pro')  {
        disabled = true;
      }
      if(lvl == this.props.Paper.paper.editor_level) {
        selected = true;
      }
      return (<option disabled={disabled} key={key} value={lvl}>{capitalize(empToPrmLevelTranslate(lvl))}</option>);
    }.bind(this));
    var tatSelectOptions = [];
    tatSelectOptions.push(<option key="select" value="">Select...</option>);
    for(var tatKey in titleVars) {
      var disabled = false;
      if(tatKey <= 3 && make3grey) {
        disabled = true;
      } else if(tatKey <= 12 && make12grey) {
        disabled = true;
      } else if(tatKey <= 24 && make24grey) {
        disabled = true;
      } else if(tatKey <= 72 && make72grey) {
        disabled = true;
      } else if(tatKey <= 96 && make96grey) {
        disabled = true;
      } else if(tatKey <= 120 && make120grey) {
        disabled = true;
      } else if(tatKey <= 240 && make240grey) {
        disabled = true;
      }
      tatSelectOptions.push(<option disabled={disabled} key={tatKey} value={tatKey}>{tatKey}h</option>);
    }
    var custom_3_label = classname({
      'make3grey': make3grey,
      'price-label' : true
    })
    var custom_12_label = classname({
      'make12grey': make12grey,
      'price-label' : true
    })
    var custom_24_label = classname({
      'make24grey': make24grey,
      'price-label' : true
    })
    var custom_72_label = classname({
      'make72grey': make72grey,
      'price-label' : true
    })
    var custom_96_label = classname({
      'make96grey': make96grey,
      'price-label' : true
    })
    var custom_120_label = classname({
      'make120grey': make120grey,
      'price-label' : true
    })
    var custom_240_label = classname({
      'make240grey': make240grey,
      'price-label' : true
    })

    var clock_color = "pricing_files/clock.png";
    switch (this.props.Paper.paper.editor_level) {
      case "silver":
        clock_color = "pricing_files/clocksilver.png"
        break;
      case "gold":
        clock_color = "pricing_files/clockgold.png"
        break;
      case "pro":
        clock_color = "pricing_files/clockpro.png"
        break;
      default:
    }

    return (
      <div>
        <Helmet>
          <title>Step 2 - Editing Options | Proofreading Manuscripts </title>
          <meta name="description" content="Use Our Quick Submission Process for Easy Document Uploading and Professional Paper Editing."></meta>
        </Helmet>
      <ReactModal
         isOpen={this.props.Modals.extras_modal}
         contentLabel="FAQ Modal"
         className="faq-modal"
      >
      <div className="modal-header">
          <div className="modal-header-text">FAQ</div>
          <i className="fa fa-times faq-modal-close fa-2x" aria-hidden="true" onClick={this.closeExtraModal.bind(this)} value="Close"></i>
      </div>
      <FAQ />
      </ReactModal>
      <ReactTooltip  multiline={true}/>
      

      <ReactModal
        isOpen={this.props.Modals.bronze_example_modal}
        contentLabel = "Modal"
        className="bronze-example-modal"
        style={{overlay: {zIndex: 9999}}}
        >
        <div className="medal-modal-wrapper">
          <div className="modal-header">
              <div className="modal-header-text">Proofreading Example</div>
              <i className="fa fa-times faq-modal-close fa-2x" aria-hidden="true" onClick={this.closeBronzeExampleModal.bind(this)} value="Close"></i>
          </div>
          <img src="pricing_files/proofreading-example.jpg" width="704" height="450"/>
        </div>
      </ReactModal>
      <ReactModal
        isOpen={this.props.Modals.silver_example_modal}
        contentLabel = "Modal"
        className="bronze-example-modal"
        style={{overlay: {zIndex: 9999}}}
        >
        <div className="medal-modal-wrapper">
          <div className="modal-header">
              <div className="modal-header-text">Standard Example</div>
              <i className="fa fa-times faq-modal-close fa-2x" aria-hidden="true" onClick={this.closeSilverExampleModal.bind(this)} value="Close"></i>
          </div>
          <img src="pricing_files/standard-example.jpg" />
        </div>
      </ReactModal>

      <ReactModal
        isOpen={this.props.Modals.gold_example_modal}
        contentLabel = "Modal"
        className="bronze-example-modal"
        style={{overlay: {zIndex: 9999}}}
        >
        <div className="medal-modal-wrapper">
          <div className="modal-header">
              <div className="modal-header-text">Ultimate Example</div>
              <i className="fa fa-times faq-modal-close fa-2x" aria-hidden="true" onClick={this.closeGoldExampleModal.bind(this)} value="Close"></i>
          </div>
          <img src="pricing_files/ultimate-example.jpg" />
        </div>
      </ReactModal>
      <TopNav inSteps={true}/>
      <section className="steps top_section">
      <Bubbles currentStep={2}></Bubbles>
      <br/><br/><br/>
      </section>
      <section className="pricing">
        <div className="container">
          <div className="row">
            <div className="container-fluid">
              <div className="pricing_wrapper">
                <table className="table table-responsive">
                  <thead>
                    <tr>
                      <th>
                        <p className="first">
                          <img src="pricing_files/stopwatch-icon.png" />
                          <a className="info" href="#" data-toggle="tooltip" data-placement="left" title="" data-original-title=""></a></p>
                        <h3>Return Time</h3>
                      </th>
                      <th>
                        <i className="fa fa-trophy package_trophy" aria-hidden="true"></i>
                        <h3>Proofreading</h3>
                        <p>Basic Proofreading</p>
                        <p className="level-description">Experts will fix your spelling, grammar and puncutation issues. <i className="extras-info  levels-info fa fa-2x fa-info-circle" aria-hidden="true" data-tip="Best option for documents requiring minimal revisions."></i></p>
                      </th>
                      <th>
                        <i className="fa fa-trophy package_trophy" aria-hidden="true"></i>
                        <h3>Standard</h3>
                        <p>Professional Editing</p>
                        <p className="level-description">All common grammar issues will be fixed and helpful comments will be provided. <i className="levels-info fa fa-2x fa-info-circle" aria-hidden="true" data-tip="Ideal option for drafts and rough papers requiring moderate revisions."></i></p>
                      </th>
                      <th>
                        <i className="fa fa-graduation-cap package_trophy" aria-hidden="true"></i>
                        <h3>Ultimate</h3>
                        <p>Top-Tier Option</p>
                        <p className="level-description">Meticulous proofreading, editing, and minor rewriting with comments and critiques. <i className="extras-info  levels-info fa fa-2x fa-info-circle" aria-hidden="true" data-tip="The most in-depth and comprehensive option with the best editor possible for your subject. 
                            <br />Your content will also be checked for obvious issues and a comment will be provided."></i></p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <h4>3 hours <i className="levels-info fa fa-2x fa-info-circle small" aria-hidden="true" 
                          data-tip="You can submit up to 2275 words to this return time" ></i></h4>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["3"]}>
                          <label className={custom_3_label} disabled={make3grey}>
                            <div className="custom-radio">
                              <input disabled={make3grey} title={titleVars["3"]} name="countries" checked={this.props.Paper.paper.editor_level === 'silver' && this.props.Paper.paper.time_limit === '3'} value="American" type="radio" onClick={this.updatePaper.bind(this, 'silver', '3')} />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['silver']['3']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["3"]}>
                          <label className={custom_3_label} disabled={make3grey}>
                            <div className='custom-radio'>
                              <input disabled={make3grey} title={titleVars["3"]} checked={this.props.Paper.paper.editor_level === 'gold' && this.props.Paper.paper.time_limit === '3'} name="countries" value="American" type="radio" onClick={this.updatePaper.bind(this, 'gold', '3')} disabled={make3grey}/>
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['gold']['3']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group">
                          <label className={custom_3_label} disabled={make3grey}>
                            <div className="custom-radio">
                              <input disabled={make3grey} name="countries" title={titleVars["3"]} value="American" type="radio" />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['pro']['3']) * pages).toFixed(2) }
                          </label>
                          <a className="info" href="#" data-toggle="tooltip" data-placement="left" title="" data-original-title="Lorem Ipsum"><div></div></a>
                        </div>
                      </td>
                    </tr>
                    <tr >
                      <td>
                        <h4>12 hours <i className="levels-info fa fa-2x fa-info-circle small" aria-hidden="true" 
                          data-tip="You can submit up to 5850 words to this return time" ></i></h4>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["12"]}>
                          <label className={custom_12_label} disabled={make12grey}>
                            <div className="custom-radio">
                              <input disabled={make12grey} title={titleVars["12"]} checked={this.props.Paper.paper.editor_level === 'silver' && this.props.Paper.paper.time_limit === '12'} name="countries" value="American" type="radio" onClick={this.updatePaper.bind(this, 'silver', '12')} />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['silver']['12']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["12"]}>
                          <label className={custom_12_label} disabled={make12grey}>
                            <div className="custom-radio">
                              <input disabled={make12grey} title={titleVars["12"]} name="countries" checked={this.props.Paper.paper.editor_level === 'gold' && this.props.Paper.paper.time_limit === '12'} value="American" type="radio" onClick={this.updatePaper.bind(this, 'gold', '12')} />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['gold']['12']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["12"]}>
                          <label className={custom_12_label} disabled={make12grey}>
                            <div className="custom-radio">
                              <input disabled={make12grey} title={titleVars["12"]} name="countries" value="American" type="radio" onClick={this.updatePaper.bind(this, 'pro', '12')} />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['pro']['12']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>24 hours <i className="levels-info fa fa-2x fa-info-circle small" aria-hidden="true" 
                          data-tip="You can submit up to 9100 words to this return time" ></i></h4>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["24"]}>
                          <label className={custom_24_label}  disabled={make24grey}>
                            <div className="custom-radio">
                              <input disabled={make24grey}  name="countries" title={titleVars["24"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'silver', '24')} />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['silver']['24']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["24"]}>
                          <label className={custom_24_label} disabled={make24grey}>
                            <div className="custom-radio">
                              <input disabled={make24grey} name="countries" title={titleVars["24"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'gold', '24')} />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['gold']['24']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["24"]}>
                          <label className={custom_24_label} disabled={make24grey}>
                            <div className="custom-radio">
                              <input disabled={make24grey} name="countries" title={titleVars["24"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'pro', '24')}/>
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['pro']['24']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>72 hours <i className="levels-info fa fa-2x fa-info-circle small" aria-hidden="true" 
                          data-tip="You can submit up to 19500 words to this return time" ></i></h4>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["72"]}>
                          <label className={custom_72_label} disabled={make72grey}>
                            <div className="custom-radio">
                              <input disabled={make72grey} name="countries" title={titleVars["72"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'silver', '72')} />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['silver']['72']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["72"]}>
                          <label className={custom_72_label} disabled={make72grey}>
                            <div className="custom-radio">
                              <input disabled={make72grey} name="countries"  title={titleVars["72"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'gold', '72')}/>
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['gold']['72']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["72"]}>
                          <label className={custom_72_label} disabled={make72grey}>
                            <div className="custom-radio">
                              <input disabled={make72grey} name="countries" title={titleVars["72"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'pro', '72')}/>
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['pro']['72']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>96 hours <i className="levels-info fa fa-2x fa-info-circle small" aria-hidden="true" 
                          data-tip="You can submit up to 32500 words to this return time" ></i></h4><span className="tat_smaller">(4 days)</span>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["96"]}>
                          <label className={custom_96_label} disabled={make96grey}>
                            <div className="custom-radio">
                              <input disabled={make96grey} name="countries" title={titleVars["96"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'silver', '96')} />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['silver']['96']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["96"]}>
                          <label className={custom_96_label} disabled={make96grey}>
                            <div className="custom-radio">
                              <input disabled={make96grey} name="countries"  title={titleVars["96"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'gold', '96')}/>
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['gold']['96']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["96"]}>
                          <label className={custom_96_label} disabled={make96grey}>
                            <div className="custom-radio">
                              <input disabled={make96grey} name="countries" title={titleVars["96"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'pro', '96')}/>
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['pro']['96']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>120 hours <i className="levels-info fa fa-2x fa-info-circle small" aria-hidden="true" 
                          data-tip="You can submit up to 40500 words to this return time" ></i></h4><span className="tat_smaller">(5 days)</span>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["120"]}>
                          <label className={custom_120_label} disabled={make120grey}>
                            <div className="custom-radio">
                              <input disabled={make120grey} name="countries" title={titleVars["120"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'silver', '120')} />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['silver']['120']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["120"]}>
                          <label className={custom_120_label} disabled={make120grey}>
                            <div className="custom-radio">
                              <input disabled={make120grey} name="countries"  title={titleVars["120"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'gold', '120')}/>
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['gold']['120']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["120"]}>
                          <label className={custom_120_label} disabled={make120grey}>
                            <div className="custom-radio">
                              <input disabled={make120grey} name="countries" title={titleVars["120"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'pro', '120')}/>
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['pro']['120']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>240 hours <i className="levels-info fa fa-2x fa-info-circle small" aria-hidden="true" 
                          data-tip="You can submit up to 110000 words to this return time" ></i></h4><span className="tat_smaller">(10 days)</span>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["240"]}>
                          <label className={custom_240_label} disabled={make240grey}>
                            <div className="custom-radio">
                              <input disabled={make240grey} name="countries" title={titleVars["240"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'silver', '240')} />
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['silver']['240']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["240"]}>
                          <label className={custom_240_label} disabled={make240grey}>
                            <div className="custom-radio">
                              <input disabled={make240grey} name="countries"  title={titleVars["240"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'gold', '240')}/>
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['gold']['240']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                      <td>
                        <div className="form-group" data-tip={titleVars["240"]}>
                          <label className={custom_240_label} disabled={make240grey}>
                            <div className="custom-radio">
                              <input disabled={make240grey} name="countries" title={titleVars["240"]} value="American" type="radio" onClick={this.updatePaper.bind(this, 'pro', '240')}/>
                              <div className="check_radio"></div>
                            </div>
                            {(parseFloat(this.props.Paper.pricing['pro']['240']) * pages).toFixed(2) }
                          </label>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="mobile-level-time-selection">
                  <div className="mobile-level-selection">
                    <label htmlFor="level">Editing Level</label>
                    <select onChange={(e) => this.updatePaperMobile(e, 'editor_level')} value={this.props.Paper.paper.editor_level} name="level">
                      {levelSelectOptions}
                    </select>
                  </div>
                  <div className="mobile-time-selection">
                    <label htmlFor="tat">Return Time</label>
                    <select onChange={(e) => this.updatePaperMobile(e, 'time_limit')} value={this.props.Paper.paper.time_limit} name="tat">
                      {tatSelectOptions}
                    </select>
                  </div>
                </div> 
              </div>
              <div className="mobile-only step2-carousel-toggle">
                <button onClick={this.toggleCarousel.bind(this)}>{this.state.editorCarouselButtonText}</button>
              </div>
              <div className={this.state.editorCarouselClasses}>
                <Slider {...settings}>
                  <div>
                    <div className="item">
                      <div className="item_wrapper">
                        <div className="col-sm-5">
                            <h2 className="silver">Ultimate</h2>
                            <ul>
                              <li>Our Ultimate package will fix your spelling, grammar, punctuation, flow, style, consistency, and provide alternative word choice suggestions. Helpful guiding comments and critiques will be provided.</li>
                            </ul>
                        </div>
                        <div className="col-sm-3">
                          <img className="thumbnail" src="pricing_files/ultimate_thumbnail.jpg" onClick={this.openGoldExampleModal.bind(this)} />
                        </div>
                        <div className="col-sm-3">
                          <p className="pricing_info">From $15 per 325 words</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="item">
                      <div className="item_wrapper">
                        <div className="col-sm-5">
                            <h2 className="silver">Standard Editing</h2>
                            <ul>
                              <li>Standard Editing will fix your spelling, grammar, punctuation, flow and consistency issues. Some helpful comments will be provided.</li>
                            </ul>
                        </div>
                        <div className="col-sm-3">
                          <img className="thumbnail" src="pricing_files/standard_thumbnail.jpg" onClick={this.openSilverExampleModal.bind(this)} />
                        </div>
                        <div className="col-sm-3">
                          <p className="pricing_info">From $10 per 325 words</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                      <div className="item">
                        <div className="item_wrapper">
                          <div className="col-sm-5">
                              <h2 className="silver">Proofreading</h2>
                              <ul>
                                <li>Proofreading will fix your spelling, grammar and punctuation.</li>
                              </ul>
                          </div>
                          <div className="col-sm-3">
                            <img className="thumbnail" src="pricing_files/proofreading_thumbnail.jpg" onClick={this.openBronzeExampleModal.bind(this)} />
                          </div>
                          <div className="col-sm-3">
                            <p className="pricing_info">From $8 per 325 words</p>
                          </div>
                        </div>
                      </div>
                  </div>
                  <div>
                      <div className="item">
                        <div className="item_wrapper">
                          <div className="col-sm-10">
                            <h2 className="silver">Your human editor will fix and improve your: spelling, grammar, punctuation, word choice, make flow improvements (including run-on sentences), improve your overall writing style, and correct any incorrectly used English words/phrases. Our editors are real, live experts and will also provide comments to further assist you.</h2>
                          </div>
                        </div>
                      </div>
                  </div>
    </Slider>
              </div>
              <div className="price_counter">
                <div className="price_counter_wrapper">
                  <div className="package silver">
                    <p className="package_time">{this.props.Paper.paper.time_limit} hours</p>
                  </div>
                  <div className="price">
                    <p className="price_details">${this.props.Paper.paper.doc_cost}</p>
                  </div>
                  <div className="words">
                    <p className="words_count">for {this.props.Paper.paper.word_count} words</p>
                  </div>
                </div>
              </div>
              <div className="question">
                <div className="faq-opener" onClick={this.openFAQModal.bind(this)}>Have questions about our <span>pricing</span>?</div>
              </div>
              <div className="button_wrapper button_center">
                <Link to="/get-started" className="button back">
                <svg width="6px" height="9px" viewBox="0 0 6 9" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                        <g id="Step-2.1A-FAQ" transform="translate(-200.000000, -945.000000)" stroke="#419BF9">
                            <g id="Group-9" transform="translate(188.000000, 936.000000)">
                                <g id="Group-16" transform="translate(0.857143, 0.000000)">
                                    <g id="Group-16-Copy" transform="translate(47.000000, 13.500000) scale(1, -1) translate(-47.000000, -13.500000) ">
                                        <path d="M12.4229503,17.2913356 L16.5101983,13.2040874" id="Line" transform="translate(14.785714, 15.500000) scale(1, -1) translate(-14.785714, -15.500000) "></path>
                                        <path d="M12.4229503,13.2913356 L16.5101983,9.20408739" id="Line"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg> back
                </Link>

                <Link to="/step3" disabled={button_next_disabled} className={active_Next} onClick={this.ChangeStep.bind(this)}>Next
                  <svg className="next-arrow" width="43px" height="43px" viewBox="0 0 43 43" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                    <defs></defs>
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g id="Step-1.2.2-w-Estimate" transform="translate(-745.000000, -845.000000)" stroke="#FFFFFF">
                        <g id="Group-15" transform="translate(746.000000, 846.000000)">
                          <circle id="Oval-11" cx="20.5" cy="20.5" r="20.5"></circle>
                          <g id="Group-14" transform="translate(17.000000, 12.000000)" strokeLinecap="square">
                            <path d="M0.357142857,0.357142857 L9.64285714,9.64285714" id="Line"></path>
                            <path d="M0.357142857,18.6428571 L9.64285714,9.35714286" id="Line-Copy-3"></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
    )
  }
}

export default connect( ({Paper, Modals})=>({Paper, Modals}) )(Step2Page);

  // <div className="carousel slide " data-ride="carousel" id="quote-carousel">
  //   <div className="carousel-inner">
  //     <div className="item active left">
  //       <div className="item_wrapper highlight" onClick={this.openBronzeExampleModal.bind(this)}>
  //         <div className="col-sm-2 text-center">
  //           <img className="medal_img" src="pricing_files/bronze-medal.png" />
  //         </div>
  //         <div className="col-sm-6">
  //             <h2 className="silver">Bronze gives you access to</h2>
  //             <ul>
  //               <li>Experienced teachers</li>
  //               <li>University Graduates or Master Students</li>
  //               <li>Perfect for second drafts or short assignments</li>
  //             </ul>
  //         </div>
  //         <div className="col-sm-4">
  //           <p className="pricing_info">From $8/page (325 words)</p>
  //         </div>
  //       </div>
  //     </div>
  //     <div className="item next left">
  //       <div className="item_wrapper" onClick={this.openSilverExampleModal.bind(this)}>
  //         <div className="col-sm-2 text-center">
  //           <img className="medal_img" src="pricing_files/silver-medal.png" />
  //         </div>
  //         <div className="col-sm-6">
  //             <h2 className="silver">Silver gives you access to</h2>
  //             <ul>
  //               <li>Experienced teachers</li>
  //               <li>University Graduates or Master Students</li>
  //               <li>Perfect for second drafts or short assignments</li>
  //             </ul>
  //         </div>
  //         <div className="col-sm-4">
  //           <p className="pricing_info">From $8/page (325 words)</p>
  //         </div>
  //       </div>
  //     </div>
  //     <div className="item">
  //       <div className="item_wrapper" onClick={this.openGoldExampleModal.bind(this)}>
  //         <div className="col-sm-2 text-center">
  //           <img className="medal_img" src="pricing_files/gold-medal.png" />
  //         </div>
  //         <div className="col-sm-6">
  //             <h2 className="silver">Gold gives you access to</h2>
  //             <ul>
  //               <li>Experienced teachers</li>
  //               <li>University Graduates or Master Students</li>
  //               <li>Perfect for second drafts or short assignments</li>
  //             </ul>
  //         </div>
  //         <div className="col-sm-4">
  //           <p className="pricing_info">From $8/page (325 words)</p>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  //   <a data-slide="prev" href="#quote-carousel" className="left carousel-control"> </a>
  //   <a data-slide="next" href="#quote-carousel" className="right carousel-control"> </a>
  // </div>
          // <div className="container">
          //   <div className="row">
          //     <div className="container-fluid" >
          //     <div className="steps_wrapper">
          //         <div className="step_item" onClick={this.ChangeStep.bind(this, '2')}>
          //           <Link to="/step1" className="step_item_number" onClick={this.ChangeStep.bind(this, '2')}>
          //             <i className="fa fa-check" aria-hidden="true" onClick={this.ChangeStep.bind(this, '2')}></i>
          //             <span className="step_item_title" onClick={this.ChangeStep.bind(this, '2')}>Upload</span>
          //           </Link>
          //         </div>
          //         <div className="step_item active" onClick={this.ChangeStep.bind(this, '2')}>
          //           <Link to="/step2" className="step_item_number" onClick={this.ChangeStep.bind(this, '2')}>
          //             2
          //             <span className="step_item_title">Pricing</span>
          //           </Link>
          //         </div>
          //         <div className="step_item">
          //           <Link to="/step3" className="step_item_number">
          //             3
          //             <span className="step_item_title">Extras</span>
          //           </Link>
          //         </div>
          //         <div className="step_item">
          //           <Link to="/step4" className="step_item_number">
          //             4
          //             <span className="step_item_title">Checkout</span>
          //           </Link>
          //         </div>
          //         </div>
          //     </div>
          //   </div>
          // </div>



// WEBPACK FOOTER //
// ./src/components/steps/step2.js